<template>
  <md-table-cell>
    <md-field md-inline>
      <md-input v-model="filterValue"/>
    </md-field>
  </md-table-cell>
</template>

<script>
import IndexTableFilter from "@/new/components/Index/IndexTableFilter";

export default {
  name: "IndexTableFilterBool",
  mixins: [IndexTableFilter],
}
</script>